import { axiosInstance } from '@services/base-service';

const configUri = '/merchant/bff/initial';

export const fetchConfig = () => axiosInstance.getInstance().get(`${configUri}/initial-data`);
